import request from '../utils/request';

/**
 * 获取站点列表
 * @returns {Promise<R>}
 */
export async function getRoomList () {
    return request(`/api/user/room/list`, {
        method: 'GET',
        requestType: 'form',
        data: {},
    })
}

export async function checkRoomStatus (params: {roomId: number}) {
    return request(`/api/user/room/check`, {
        method: 'POST',
        requestType: 'form',
        data: params,
    })
}



